import SidebarService from '../../../services/SidebarService';
import Connect from '../../../services/Connect';

export default function goToReport() {
  SidebarService.updateSelectType('Text', true);
  Connect.setSelectType('Text', true);
}
